<script>
	import {renderRichText} from "@storyblok/svelte";
	import { page } from '$app/stores';
	export let data;

	$: pageIntro = renderRichText(data.globaleInstellingen.content.pagina_intro);
</script>

{#if data.globaleInstellingen}
	{#if $page.status === 404}
	<div class="header-error">
        <div class="container">
			<div class="text-holder">
				<div class="icon-holder">
					<script src="https://cdn.lordicon.com/bhenfmcm.js"></script>
					<lord-icon
						src="https://cdn.lordicon.com/zlhhhefv.json"
						trigger="loop"
						delay="2000"
						colors="primary:#E83C2C,secondary:#08004C"
						style="width:150px;height:150px">
					</lord-icon>
				</div>

				<h1 class="mb-[20px]">{data.globaleInstellingen.content.pagina_titel}</h1>
				<div class="intro-container">
					<div class="intro-holder">
						<div>{@html pageIntro}</div>
					</div>
				</div>
			</div>
		</div>
    </div>
	{:else}
	<div class="header-error">
		<div class="container">
			<div class="text-holder">
				<div class="icon-holder">
					<script src="https://cdn.lordicon.com/bhenfmcm.js"></script>
					<lord-icon
						src="https://cdn.lordicon.com/zlhhhefv.json"
						trigger="loop"
						delay="2000"
						colors="primary:#E83C2C,secondary:#08004C"
						style="width:150px;height:150px">
					</lord-icon>
				</div>

				<h1 class="mb-[20px]">{$page.status}</h1>
				<div class="intro-container">
					<div class="intro-holder">
						<div>{$page.error.message}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	{/if}
{/if}
<style lang="postcss">
	.header-error {
		background-color: var(--content-background);
		padding: 100px 0;
	}

	.text-holder {
		text-align: center;
		max-width: 670px;
		margin: 0 auto;
	}
</style>